import { Box, useTheme } from "@mui/material";
import CustomLabel from "./custom-label";
import StyledTextField, { ExtendedTextFieldProps } from "./styled-text-field";

const StyledTextFieldWithTitle = (props: ExtendedTextFieldProps) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {props.title && (
          <CustomLabel
            sx={{
              ...theme.nawy.typography.english.variants.body.xs.regular,
              ...props.labelSx,
            }}
          >
            {props.title}
          </CustomLabel>
        )}
        {(props.required || props.error) && (
          <CustomLabel sx={{ color: "red" }}>*</CustomLabel>
        )}
      </Box>
      <StyledTextField {...props}></StyledTextField>
    </Box>
  );
};

export default StyledTextFieldWithTitle;
